// extracted by mini-css-extract-plugin
export default {"adminContainer":"style_adminContainer__IK7AR","adminContainer__linkBack":"style_adminContainer__linkBack__Ln21W","adminContainer__title":"style_adminContainer__title__fGW+r"};